<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const { t } = useI18n();

const update = taxTypeIds =>
  emit('update:value', { ...props.value, tax_type_ids: taxTypeIds });
const attentionPoints = computed(() => [
  {
    id: 'taxa_incendio_atrasada',
    tag: t('POST_SALE.TOPICS.TAXES.ATTENTION.FIRE.TAG'),
    text: t('POST_SALE.TOPICS.TAXES.ATTENTION.FIRE.TEXT'),
  },
  {
    id: 'dividas_iptu',
    tag: t('POST_SALE.TOPICS.TAXES.ATTENTION.IPTU.TAG'),
    text: t('POST_SALE.TOPICS.TAXES.ATTENTION.IPTU.TEXT'),
  },
  {
    id: 'nono_distribuidor',
    tag: t('POST_SALE.TOPICS.TAXES.ATTENTION.DISTRIBUTOR.TAG'),
    text: t('POST_SALE.TOPICS.TAXES.ATTENTION.DISTRIBUTOR.TEXT'),
  },
]);
const selectedAttentionPoints = computed(() =>
  attentionPoints.value.filter(point =>
    props.value.tax_type_ids?.includes(point.id)
  )
);
</script>

<template>
  <div class="grid gap-4">
    <h2 class="text-lg font-semibold text-lais-text">
      {{ t('POST_SALE.TOPICS.TAXES.TITLE') }}
    </h2>
    <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
      {{ t('POST_SALE.TOPICS.TAXES.MUNICIPAL_REGISTRATION') }}
      <input
        :value="catalog.property?.municipal_registration || ''"
        class="min-h-10 rounded-lais border border-lais-border bg-lais-bg-soft px-2 font-normal"
        readonly
      />
    </label>
    <fieldset class="grid gap-2">
      <legend class="text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.TAXES.PENDING') }}
      </legend>
      <label
        v-for="option in catalog.tax_types || []"
        :key="option.id"
        class="flex items-center gap-2 text-sm text-lais-text-body"
      >
        <input
          type="checkbox"
          :checked="value.tax_type_ids?.includes(option.id)"
          @change="
            update(
              $event.target.checked
                ? [...(value.tax_type_ids || []), option.id]
                : (value.tax_type_ids || []).filter(id => id !== option.id)
            )
          "
        />
        {{ option.label }}
      </label>
    </fieldset>

    <section
      v-if="selectedAttentionPoints.length"
      class="rounded-lais border border-lais-border-soft bg-lais-bg-soft p-4"
    >
      <p class="text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.TAXES.ATTENTION_TITLE') }}
      </p>
      <div
        v-for="point in selectedAttentionPoints"
        :key="point.id"
        class="mt-3 grid gap-2"
      >
        <span
          class="w-fit rounded-full bg-lais-primary-50 px-2 py-1 text-xs font-semibold text-lais-primary"
        >
          {{ point.tag }}
        </span>
        <p class="text-sm font-semibold text-lais-text-body">
          {{ point.text }}
        </p>
      </div>
    </section>
  </div>
</template>
